module.exports = __webpack_public_path__ + "img/car.4c8ad45e.svg";